(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.fv-slider').forEach(function (slider) {
      var interval = parseInt(slider.getAttribute('data-interval') || '4500', 10);
      var switchMs = parseInt(slider.getAttribute('data-switch') || '800', 10);

      slider.style.setProperty('--switch', (switchMs / 1000) + 's');

      var slides = Array.prototype.slice.call(slider.querySelectorAll('.fv-slide'));
      if (slides.length <= 1) {
        if (slides[0]) slides[0].classList.add('is-active');
        return;
      }

      var hasActive = slides.some(function (s) { return s.classList.contains('is-active'); });
      if (!hasActive) slides[0].classList.add('is-active');

      var i = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      if (i < 0) i = 0;

      setInterval(function () {
        var current = slides[i];
        i = (i + 1) % slides.length;
        var next = slides[i];
        current.classList.remove('is-active');
        next.classList.add('is-active');
      }, interval);
    });
  });
})();